import API, {
  apiGetCached,
  createAxiosHeaders,
  invalidateApiCache,
} from "./api";

const SITE_SETTINGS_ENDPOINT = "/api/site-settings/";
const PAYMENT_STATUS_ENDPOINT = "/api/pay/status/";

const settingsCacheKey = `GET|${SITE_SETTINGS_ENDPOINT}`;
const paymentStatusPrefix = `GET|${PAYMENT_STATUS_ENDPOINT}`;

const payApi = {
  createTransaction: async (amount, callbackUrl) => {
    const response = await API.post(
      "/api/pay/create/",
      { amount, callback: callbackUrl },
      createAxiosHeaders()
    );
    payApi.invalidatePaymentStatus();
    return response;
  },

  getSiteSettings: ({ force = false } = {}) =>
    apiGetCached(
      SITE_SETTINGS_ENDPOINT,
      {},
      { force, ttlMs: 5 * 60 * 1000, cacheKey: settingsCacheKey }
    ),

  verifyTransaction: async (amount, transid) => {
    const response = await API.post(
      "/api/pay/verify/",
      { amount, transid },
      createAxiosHeaders()
    );
    payApi.invalidatePaymentStatus();
    return response;
  },

  getPaymentStatus: ({ force = false } = {}) => {
    const token = localStorage.getItem("access_token") || "";
    const cacheKey = `${paymentStatusPrefix}|${token}`;
    return apiGetCached(
      PAYMENT_STATUS_ENDPOINT,
      createAxiosHeaders(),
      { force, ttlMs: 15 * 1000, cacheKey }
    );
  },

  invalidatePaymentStatus: () => {
    invalidateApiCache((key) => key.startsWith(paymentStatusPrefix));
  },
};

export default payApi;
